import React, { useState } from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { filterStraddleHistoryData } from "../../utils/filterFunctions";

export default function FilterStraddleHistoryModal({
  showFilter,
  handleCloseFilter,
  fyersStraddleHistoryData,
  setFilteredFyersStraddleHistoryData
}) {
  const [filters, setFilters] = useState({
    underlying_scrip_code: "",
    datetime: "",
    straddle_ratio: "",
    underlying_ltp: "",
    ce_ltp: "",
    pe_ltp: "",
  });

  const handleInputChange = (e, filterKey) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey]: e.target.value,
    }));
  };

  const handleApplyFilters = () => {
    const filtersToApply = {};

    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== "") {
        filtersToApply[key] = value;
      }
    }

    console.log("Filters to apply",filtersToApply)

    filterStraddleHistoryData(
      filtersToApply,
      fyersStraddleHistoryData,
      setFilteredFyersStraddleHistoryData
    );
   
  };

  return (
    <tr
      className={` h-[70px]  bg-[#07F2C7]/20 border-gray-800 
         ${
           showFilter
             ? "animate-slideDown transition duration-500 ease-in"
             : "animate-slideUp transition duration-500 ease-in"
         } `}
    >
      <th className=" px-2 ">
        <input
          type="text"
          placeholder="Symbol"
          value={filters.underlying_scrip_code}
          className=" py-2 px-1 w-full font-normal text-white/80 placeholder-white/40 text-sm focus:outline none border-[1px] border-white/10 bg-[#fff]/10 rounded-sm"
          onChange={(e) => handleInputChange(e, "underlying_scrip_code")}
        />
      </th>
      
      
      
      <th className=" px-2  ">
        <input
          type="number"
          placeholder="Straddle Ratio"
          value={filters.straddle_ratio}
          className="py-2 px-1 w-full font-normal text-white/80 placeholder-white/40 text-sm focus:outline none border-[1px] border-white/10 bg-[#fff]/10 rounded-sm"
          onChange={(e) => handleInputChange(e, "straddle_ratio")}
        />
      </th>
      <th className=" px-2  ">
        <input
          type="number"
          placeholder="LTP"
          value={filters.underlying_ltp}
          className="py-2 px-1 w-full font-normal text-white/80 placeholder-white/40 text-sm focus:outline none border-[1px] border-white/10 bg-[#fff]/10 rounded-sm"
          onChange={(e) => handleInputChange(e, "underlying_ltp")}
        />
      </th>
      <th className=" px-2  ">
        <input
          type="number"
          placeholder="CALL LTP"
          value={filters.ce_ltp}
          className="py-2 px-1 w-full font-normal text-white/80 placeholder-white/40 text-sm focus:outline none border-[1px] border-white/10 bg-[#fff]/10 rounded-sm"
          onChange={(e) => handleInputChange(e, "ce_ltp")}
        />
      </th>
      <th className=" px-22 ">
        <input
          type="number"
          placeholder="PUT LTP"
          value={filters.pe_ltp}
          className="py-2 px-1 w-full font-normal text-white/80 placeholder-white/40 text-sm focus:outline none border-[1px] border-white/10 bg-[#fff]/10 rounded-sm"
          onChange={(e) => handleInputChange(e, "pe_ltp")}
        />
      </th>
      <th className=" px-2  ">
        <span className="flex items-center space-x-3 ">
          <input
            type="date"
            placeholder="Date"
            value={filters.datetime}
            className="py-2 px-1 w-full font-normal text-white/80 placeholder-white/40  text-sm focus:outline none border-[1px] border-white/10 bg-[#fff]/10 rounded-sm"
            onChange={(e) => handleInputChange(e, "datetime")}
          />
          <span
            onClick={handleApplyFilters}
            className="flex items-center justify-center cursor-pointer  rounded-md  h-8 w-8"
          >
            <CheckIcon className="h-5 w-5 text-[#07F2C7] " />
          </span>
          <span
            onClick={handleCloseFilter}
            className="flex items-center justify-center cursor-pointer  rounded-md  h-8 w-8"
          >
            <XIcon className="h-5 w-5 text-rose-500 " />
          </span>
        </span>
      </th>
      
    </tr>
  );
}
